import { SwiperSlide } from 'swiper/react';
import { Heading } from 'yoso';
import { breakpoints } from '~/components/Breakpoint/Breakpoint.hook';
import { GuideCard } from '~/components/Card/Guide/GuideCard';
import { Carousel, CarouselProps } from '~/components/Carousel';
import guideStyles from '~/components/Guide/Guide.module.scss';
import { T } from '~/components/I18n';
import fnsa from '~/components/Icon/fnsa-briefcase.png';
import bulbOnBook from './bulbOnBook.png';
import hemisphere from './hemisphere.png';

const defaultCarouselProps: CarouselProps = {
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 10,
    },
    [breakpoints.medium]: {
      slidesPerView: 3,
      spaceBetween: 21,
    },
  },
  shadow: true,
};

export const LandEventGuide = () => (
  <div className={guideStyles.root}>
    <div className={guideStyles.header}>
      <Heading level={4} className={guideStyles.title}>
        <T name="citizen_land_guide_process_title" />
      </Heading>
    </div>
    <div className={guideStyles.body}>
      <Carousel {...defaultCarouselProps} className={guideStyles.carousel}>
        <SwiperSlide className={guideStyles.slide}>
          <GuideCard
            className={guideStyles.card}
            title={<T name="citizen_unit_step1" />}
            description={<T name="citizen_land_guide_process_desc1" />}
            image={<img src={hemisphere} alt="hemisphere" width={180} height={180} />}
          />
        </SwiperSlide>
        <SwiperSlide className={guideStyles.slide}>
          <GuideCard
            className={guideStyles.card}
            title={<T name="citizen_unit_step2" />}
            description={<T name="citizen_land_guide_process_desc2" />}
            image={<img src={bulbOnBook} alt="bulb on book" width={180} height={180} />}
          />
        </SwiperSlide>
        <SwiperSlide className={guideStyles.slide}>
          <GuideCard
            className={guideStyles.card}
            title={<T name="citizen_unit_step3" />}
            description={<T name="citizen_land_guide_process_desc3" />}
            image={<img src={fnsa} alt="fnsa" width={180} height={180} />}
          />
        </SwiperSlide>
      </Carousel>
    </div>
  </div>
);
